import React from "react";
import { Table, Tag, Transfer } from "antd";
import type { TableRowSelection } from "antd/es/table/interface";
import type { TransferItem, TransferProps } from "antd/es/transfer";
import difference from "lodash/difference";

interface DataType {
  key: string;
  title: string;
  description: string;
  disabled: boolean;
  tag: string;
}

interface TableTransferProps extends TransferProps<TransferItem> {
  dataSource: DataType[];
  showModalFormVehicle: (rowData: any) => void;
}

const TableTransfer = ({ showModalFormVehicle, ...restProps }: TableTransferProps) => (
  <Transfer {...restProps}>
    {({ direction, filteredItems, onItemSelectAll, onItemSelect, selectedKeys: listSelectedKeys, disabled: listDisabled }) => {
      const columnsLeft: any = [
        {
          title: "Kode Unit",
          dataIndex: "key",
        },
        {
          title: "No Mesin",
          dataIndex: "title",
        },
        {
          title: "Deskripsi",
          dataIndex: "description",
        },
      ];
      const columnsRight: any = [
        {
          title: "Kode Unit",
          dataIndex: "key",
        },
        {
          title: "No Mesin",
          dataIndex: "title",
        },
        {
          title: "Deskripsi",
          dataIndex: "description",
        },
        {
          title: "Action",
          dataIndex: "key",
          render: (value: string, row: any) => {
            return (
              <React.Fragment>
                <Tag color="#2db7f5" style={{ cursor: "pointer" }} onClick={() => showModalFormVehicle(row)}>
                  Lengkapi Data
                </Tag>
              </React.Fragment>
            );
          },
        },
      ];

      const columns = direction === "left" ? columnsLeft : columnsRight;

      const rowSelection: TableRowSelection<TransferItem> = {
        getCheckboxProps: (item) => ({ disabled: listDisabled || item.disabled }),
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows.filter((item) => !item.disabled).map(({ key }) => key);
          const diffKeys = selected ? difference(treeSelectedKeys, listSelectedKeys) : difference(listSelectedKeys, treeSelectedKeys);
          onItemSelectAll(diffKeys as string[], selected);
        },
        onSelect({ key }, selected) {
          onItemSelect(key as string, selected);
        },
        selectedRowKeys: listSelectedKeys,
      };

      return (
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={filteredItems}
          size="small"
          style={{ pointerEvents: listDisabled ? "none" : undefined }}
          onRow={({ key, disabled: itemDisabled }) => ({
            onClick: () => {
              if (itemDisabled || listDisabled) return;
              onItemSelect(key as string, !listSelectedKeys.includes(key as string));
            },
          })}
        />
      );
    }}
  </Transfer>
);
export default TableTransfer;
